import React from 'react';
import ReactDOM from 'react-dom';
import SimpleSlider from '../carousel-react/src/components/carousel';
import Searchbar from '../components/Searchbar';
import { subscriber } from '../config';
import { A4map } from '../hearbymap/src/A4map/A4map';
import { getNearestDma } from '../utils/dma';
import '../index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../hearbymap/src/css/hearby-widget-map-1.0.css';
import '../carousel-react/src/css/hearby-widget-reactcarousel-1.0.css';
import '../hearby-widget-powersearchbar-1.1.css';

function renderComponents(settings, carouselConfig) {
    const theme = settings.theme;
    const components = settings.components;
    const powersearchClass = `hearby-powersearch-widget hearby-cw-theme-${theme}`;
    settings.subscriber = subscriber;
    if( !window.componentsLoaded) {
    ReactDOM.render(
      <React.StrictMode>
        <div className={powersearchClass}>
          <Searchbar settings={settings} />
        </div>
      </React.StrictMode>,
      document.getElementById(settings.powersearchId)
    );
    if(components.carousel === true) {
        const carouselClass = `hearby-carousel-widget hearby-cw-theme-${theme}`;
    
        ReactDOM.render(
          <React.StrictMode> 
              <div className={carouselClass}>
                <SimpleSlider mainCarouselConfigObj={carouselConfig} 
                  settings={settings}/>
              </div>
          </React.StrictMode>,
          document.getElementById(settings.carouselId),
        );
      }
    
     // const dma = getNearestDma(newPos.lat, newPos.lon);
    
      if(components.map === true) {
        window.aMap = new A4map({
        gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
        menuOptions: { search: true, eventPopUp: true },
        loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
        distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
        subscriber: settings.subscriber,
        });
    
      window.aMap.init();
    
    }
    window.componentsLoaded = true;

} else {
    if(!window.userLocLoaded) {
            if(!window.defaultLocLoaded || !window.userLocLoaded){
                window.changeSearchBarLoc(settings.defaultLocation.lat, settings.defaultLocation.lon);
            }

        
        if(components.carousel && (!window.defaultLocLoaded || !window.userLocLoaded)) {
        window.changePowersearchLoc(settings.defaultLocation.lat, settings.defaultLocation.lon);
        }
        if(components.map === true && ((!window.defaultLocLoaded && !window.userLocLoaded) || (window.defaultLocLoaded && !window.userLocLoaded))) {
    //        console.log('render ', window.defaultLocLoaded, window.userLocLoaded );

            window.aMap = new A4map({
            gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
            menuOptions: { search: true, eventPopUp: true },
            loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
            distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
            subscriber: settings.subscriber,
            });
        
          window.aMap.init();
        
        }
    }

}
}

function renderComponentsDma(settings, carouselConfig) {
    const theme = settings.theme;
    const components = settings.components;
    const pos = settings.defaultLocation;
    const dma = getNearestDma(pos.lat, pos.lon);
  //  console.log('nearest dma is ', dma, settings.defaultLocation);
    
    settings.defaultLocation = {lat: dma.center.lat, lon: dma.center.lon};
    carouselConfig.lat = dma.center.lat;
    carouselConfig.lon = dma.center.lon;
    settings.subscriber = dma.tag;

    const powersearchClass = `hearby-powersearch-widget hearby-cw-theme-${theme}`;

    if( !window.componentsLoaded) {
        ReactDOM.render(
          <React.StrictMode>
            <div className={powersearchClass}>
              <Searchbar settings={settings} />
            </div>
          </React.StrictMode>,
          document.getElementById(settings.powersearchId)
        );
        if(components.carousel === true) {
            const carouselClass = `hearby-carousel-widget hearby-cw-theme-${theme}`;
        
            ReactDOM.render(
              <React.StrictMode> 
                  <div className={carouselClass}>
                    <SimpleSlider mainCarouselConfigObj={carouselConfig} 
                      settings={settings}/>
                  </div>
              </React.StrictMode>,
              document.getElementById(settings.carouselId),
            );
          }
        
         // const dma = getNearestDma(newPos.lat, newPos.lon);
        
          if(components.map === true) {
            window.aMap = new A4map({
                gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
                menuOptions: { search: true, eventPopUp: true },
                loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
                distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
                bounds: dma.bounds,
                subscriber: settings.subscriber,
                });
        
          window.aMap.init();
        
        }
        window.componentsLoaded = true;
    
    } else {
        if(!window.userLocLoaded) {
                if(!window.defaultLocLoaded || !window.userLocLoaded){
                    window.changeSearchBarLoc(settings.defaultLocation.lat, settings.defaultLocation.lon);
                }
    
            
            if(components.carousel && (!window.defaultLocLoaded || !window.userLocLoaded)) {
     //           console.log('render dma carousel ',window.defaultLocLoaded, window.userLocLoaded, settings.defaultLocation);
                window.changePowersearchLocDMA(settings.defaultLocation.lat, settings.defaultLocation.lon, dma.tag);
            }
            if(components.map === true && ((!window.defaultLocLoaded && !window.userLocLoaded) || (window.defaultLocLoaded && !window.userLocLoaded))) {
                console.log('render dma ', window.defaultLocLoaded, window.userLocLoaded );
                window.aMap = new A4map({
                    gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
                    menuOptions: { search: true, eventPopUp: true },
                    loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
                    distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
                    bounds: dma.bounds,
                    subscriber: settings.subscriber,
                    });
            
              window.aMap.init();
            
            }
        }
    
    }




//     ReactDOM.render(
//       <React.StrictMode>
//         <div className={powersearchClass}>
//           <Searchbar settings={settings} />
//         </div>
//       </React.StrictMode>,
//       document.getElementById(settings.powersearchId)
//     );
    
  
//     if(components.carousel === true) {
//       const carouselClass = `hearby-carousel-widget hearby-cw-theme-${theme}`;
  
//       ReactDOM.render(
//         <React.StrictMode> 
//             <div className={carouselClass}>
//               <SimpleSlider mainCarouselConfigObj={carouselConfig} 
//                 settings={settings}/>
//             </div>
//         </React.StrictMode>,
//         document.getElementById(settings.carouselId),
//       );
//     }

  
//     if(components.map === true) {
//       window.aMap = new A4map({
//       gApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
//       menuOptions: { search: true, eventPopUp: true },
//       loc: { lat: settings.defaultLocation.lat, lng: settings.defaultLocation.lon },
//       distance: settings.powersearchBarOpts.distanceOpts.defaultDistance,
//       bounds: dma.bounds,
//       subscriber: settings.subscriber,
//       });
  
//     window.aMap.init();
  
//   }

}

export { renderComponents, renderComponentsDma }